<template>
  <v-tabs-items v-model="selectedTab">
    <v-tab-item v-for="(tab, i) in viewConfig.tabs" :key="i">
      <list-of-sections v-if="tab.layout === 'ListOfSections'" :tab="tab" :sections="tab.sections"></list-of-sections>
      <responsive-grid v-if="tab.layout === 'ResponsiveGrid'" :sections="tab.sections"></responsive-grid>
    </v-tab-item>
  </v-tabs-items>
</template>

<script>
import config from '@/common/config';
import ListOfSections from '@/view-layouts/ListOfSections';
import ResponsiveGrid from '@/view-layouts/ResponsiveGrid';
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'TabsView',
  components: {
    ListOfSections,
    ResponsiveGrid,
  },
  mounted() {
    console.debug('Mounted TabsView instance', this.viewConfig);
  },
  data() {
    return {};
  },
  computed: {
    selectedTab() {
      return this.$store.state.tabview.selectedTabByPath[this.$route.path];
    },
    viewConfig() {
      return this.$route.meta.viewConfig;
    },
  },
  watch: {
    selectedTab(newValue, oldValue) {
      this.$vuetify.goTo(0); //scroll to top when the user changes tab
    },
  },
};
</script>
